import React, { useContext } from "react";
import "../landing/Landing.css";
import { Context } from "../../context/Context";
import { WhatsAppFloat } from "../../components/landing/WhatsAppFloat/WhatsAppFloat";
import { RequestDemo } from "../../components/landing/requestDemo/RequestDemo";

export const ContactUsPage = () => {
  const { lang } = useContext(Context);

  return (
    <div className={`landing-page ${lang === "ar" ? "ar" : "en"}`}>
      <RequestDemo />
      <WhatsAppFloat />
    </div>
  );
};

export default ContactUsPage;
